import _ from "lodash";
import { FC, useEffect, useMemo, useState, useCallback } from "react";
import {
  Card,
  Col,
  Empty,
  Row,
  Skeleton,
  Tabs,
  TabsProps,
  Flex,
  Button,
  message,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useMediaQuery } from "react-responsive";

import usePackage from "stores/usePackage";
import { ReactComponent as IconPencil } from "assets/images/pencil.svg";
import { ReactComponent as GlazingWindow } from "assets/images/glazing-window.svg";
import { ReactComponent as FloorHigh } from "assets/images/floor_high.svg";
import { ReactComponent as IconWall } from "assets/images/renovation/wall.svg";
import { ReactComponent as IconAir } from "assets/images/renovation/air-conditioner.svg";
import { ReactComponent as IconDoor } from "assets/images/renovation/door.svg";
import { ReactComponent as IconHouse } from "assets/images/renovation/house.svg";
import { ReactComponent as IconWater } from "assets/images/renovation/water.svg";
import { ReactComponent as IconRise } from "assets/images/renovation/rise.svg";
import { ReactComponent as IconEuro } from "assets/images/renovation/euro.svg";
import { ReactComponent as ValuePlus } from "assets/images/renovation/value-plus.svg";
import { ReactComponent as ValuePlus2 } from "assets/images/renovation/value-plus2.svg";
import { ReactComponent as IconBar } from "assets/images/renovation/bar.svg";
import { ReactComponent as IconStarContact }  from "assets/images/insight.svg";
import useCommonStore from "stores/useCommon";


import { MAP_COLOR_DPE } from "constants/index";
import PAGES from "routes/constants";
import { HouseConstruction } from "assets/images";

// import { useChainlitMutation } from "../../mutations/useChainlitMutation";
// import { useSvgLeakageMutation } from "../../mutations/useSvgLeakageMutation";
import { useGetReliabilityQuery } from "../../queries/useGetReliabilityQuery";

import useInsight from "stores/useInsight";
import { BUTTON_ID } from "constants/insight";

import API from "services/api";
import { formatThousands } from "utils";

interface Props {
  id: string;
  dataSuggestion: any;
  dataHomeUploaded: any;
  openChainLit: () => void;
}

const MAP_ICON: any = {
  wall: IconWall,
  ceiling: IconHouse,
  heating: IconAir,
  doorswindows: IconDoor,
  hotwater: IconWater,
  hot_water: IconWater,
  window: GlazingWindow,
  floor_high: FloorHigh,
};

const SuggestionRenovation: FC<Props> = ({
  id,
  dataSuggestion,
  dataHomeUploaded,
  // openChainLit,
}) => {
  const navigate = useNavigate();
  const [messageApi] = message.useMessage();
  const [tab, setTab] = useState("");
  // const [svgLeakage, setSvgLeakage] = useState<string | null>(null);
  const { redirectUrl, setRedirectUrl } = usePackage();
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });

  const [ResultatDPE, setResultatDPE] = useState(null);
  const [isLoadingDPE, setIsLoadingDPE] = useState(true);

  // const { mutateAsync } = useChainlitMutation();
  const { data: reliabilities } = useGetReliabilityQuery(id);
  // const { mutateAsync: mutateSvg } = useSvgLeakageMutation();

  // const { mutateAsync: mutateRenovationGraph,  isSuccess: isSuccessDPE } = useMutation({
  //   mutationFn: (params: any)  => API.mock.getRenovationGraph(params),
  //   retry: 0,
  // });

  const { mutateAsync: mutateDPE, isSuccess: isSuccessDPE } = useMutation({
    mutationFn: (params: any) => API.mock.getResultat(params),
    retry: 0,
  });

  const loadData = async (iter?: string) => {
    try {
      // const result = await mutateRenovationGraph();
      let activeTab = null;
      if (iter !== undefined) {
        activeTab = dataSuggestion.find((item: any) => item.iter === iter);
      } else {
        activeTab = dataSuggestion.find((item: any) => item.recommended);
      }
      const resultSVG = await mutateDPE({
        id,
        type: "reno",
        kwh: _.get(activeTab, "numbered_gain[0]", 0),
        co2: _.get(activeTab, "numbered_gain[1]", 0),
      });
      setResultatDPE(resultSVG);
    } catch (e: any) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
        duration: 2,
      });
    } finally {
      setIsLoadingDPE(false);
    }
  };

  const isConstruction = reliabilities?.offer === "Construction";
  const isPending = reliabilities?.guidance_status === "pending";
  const isPrePending = reliabilities?.guidance_status === "prepending";

  const { setIsShowInsight } =
    useCommonStore();

  const { setButtonId } = useInsight();



  const handleClickDemarrer = () => {
    setRedirectUrl(window.location.hash.slice(1));
    navigate(PAGES.stripe, {
      state: {
        offerId: "3",
        refAdeme: dataHomeUploaded.ademe,
        address: dataHomeUploaded.project_details.address,
      },
    });
  };

  const handleToInsight = useCallback(() => {
    setButtonId(BUTTON_ID.DEMARRER);
    setIsShowInsight(true);
  }, [setIsShowInsight]);

  const handleChangeTab = (value: string) => {
    setTab(value);
    loadData(value);
  };

  // const handleopenChainlit = async () => {
  //   await mutateAsync({
  //     ref_ademe: id,
  //     from: "control_renovation",
  //     from_details: {},
  //   });
  //   openChainLit();
  // };

  useEffect(() => {
    if (!_.isEmpty(dataSuggestion)) {
      const activeTab = dataSuggestion.find((item: any) => item.recommended);
      setTab(activeTab.iter);
    }
  }, [dataSuggestion]);

  useEffect(() => {
    const vosScenarios = document.getElementById("vos-scenarios");
    if (redirectUrl && vosScenarios) {
      vosScenarios.scrollIntoView();
      setRedirectUrl("");
    }
  }, [redirectUrl, setRedirectUrl]);

  useEffect(() => {
    loadData();
    // activate this when login is fixed
    // mutateSvg({
    //   id,
    // }).then((data) => setSvgLeakage(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabMapItems: TabsProps["items"] = dataSuggestion.map(
    (tabContent: any) => ({
      key: tabContent.iter,
      label: tabContent.tab_title ?? `Scénario ${tabContent.iter}`,
      children: (
        <div>
          <h4 className="font-bold text-[32px] mb-6">
            {tabContent.title ?? `Scénario ${tabContent.iter} proposé par checkDPE`}
          </h4>
          <p className="text-[20px] mb-6">
            {tabContent.description ?? ""}
          </p>

          <div className="flex flex-col gap-y-6">
            {!_.isEmpty(tabContent.projects) &&
              tabContent.projects
                .slice(0, isConstruction ? 2 : tabContent.projects.length)
                .map((item: any, index: number) => {
                  const Icon = MAP_ICON[item.object];
                  return (
                    <div
                      key={index}
                      className={classNames("suggestion-item", {
                        active: item.hightlight,
                      })}
                    >
                      <div className="flex items-center justify-between flex-wrap gap-y-2">
                        <p className="flex items-center gap-x-2.5 text-[20px] font-bold">
                          {Icon && <Icon className="w-10 h-10" />}
                          <span>{item.title}</span>
                        </p>

                        <div className="flex items-center gap-x-6">
                          <div className="flex items-center">
                            <span className="font-semibold text-[16px] mr-1">
                              Gain
                            </span>
                            {[...new Array(4)].map((__, index) => (
                              <IconRise
                                key={index}
                                className={classNames("icon-stat", {
                                  "icon-stat--active": item.gain >= index + 1,
                                })}
                              />
                            ))}
                          </div>

                          <div className="flex items-center">
                            <span className="font-semibold text-[16px] mr-1">
                              Prix
                            </span>
                            {[...new Array(4)].map((__, index) => (
                              <IconEuro
                                key={index}
                                className={classNames("icon-stat", {
                                  "icon-stat--active": item.cost >= index + 1,
                                })}
                              />
                            ))}
                          </div>
                        </div>
                      </div>

                      {!_.isEmpty(item.description) &&
                        item.description.map((desc: string, index: number) => (
                          <p className="text-[20px] mt-1" key={index}>
                            {desc}
                          </p>
                        ))}
                    </div>
                  );
                })}
          </div>
        </div>
      ),
    })
  );

  // const mapColor = (value: string) => {
  //   switch (value) {
  //     case "error":
  //       return "bg-red-400";
  //     case "warning":
  //       return "bg-orange-400";
  //     case "info":
  //       return "bg-green-400";
  //   }
  // };

  const selectedTabContent = useMemo(() => {
    return dataSuggestion.find((item: any) => item.iter === tab);
  }, [dataSuggestion, tab]);

  return (
    <div className="energy-home__suggestion-renovation">
      {(isConstruction || isPending || isPrePending ) && (
        <Card className="mb-3 relative">
          <div className="bloc-container">
            <div className="text-container">
              <h3 className="title">
                <IconPencil className="flex-shrink-0" />
                <span>Les travaux pour améliorer mon DPE</span>
              </h3>

              <div className="description-container">
                <div className="text-justify text-medium mt-1">
                  Dans votre DPE vous trouverez 1 ou 2 scénarios de travaux pour
                  améliorer la performance de votre logement (vous pouvez les
                  consulter en p.5 du rapport pdf de votre DPE).
                </div>
                <div className="text-justify text-medium mt-1">
                  Si vous le souhaitez, <b>checkDPE</b> vous propose, en
                  complément de ce rapport fiabilité, de construire un scénario
                  adapté à votre besoin (gain de lettre, budget, ...).
                </div>
                <div className="text-justify text-medium mt-1">
                  Pour démarrer votre projet avec <b>checkDPE</b> et souscrire
                  au complément trauvaux de l'offre Fiabilité, veuillez cliquer
                  sur le bouton ci-dessous:
                </div>
              </div>
            </div>

            <div className="house-icon">
              <img
                src={HouseConstruction}
                alt="House Construction"
                className="w-44 h-52"
              />
            </div>
          </div>

          {isConstruction && (
            <div className="construction-container border-[3px] border-green rounded-[16px] p-4 mt-4">
              <div className="title text-center">
                <span className="text-gray-400 font-extrabold">Fiabilité</span>
                &nbsp;
                <span className="text-green font-extrabold">
                  + Complément travaux
                </span>
              </div>

              <div className="subTitle font-extrabol text-gray-800 text-center">
                +50 €
              </div>

              <div className="list">
                <ul className="text-gray-500">
                  <li className="flex items-center space-x-2">
                    <span className="text-green-500">✔</span>
                    <span className="text-[16px]">
                      Score de fiabilité de mon DPE
                    </span>
                  </li>
                  <li className="flex items-center space-x-2 mt-2">
                    <span className="text-green-500">✔</span>
                    <span className="text-[16px]">
                      Identification des anomalies
                    </span>
                  </li>
                  <li className="flex items-center space-x-2 mt-2">
                    <span className="text-green-500">✔</span>
                    <span className="text-[16px]">
                      Comparaison de mon DPE aux logements similaires
                    </span>
                  </li>
                </ul>

                <ul
                  className="extra-list font-extrabold"
                  style={{ marginTop: 0 }}
                >
                  <li className="flex items-center space-x-2 text-[16px]">
                    <span className="text-green-500">✔</span>
                    <span>Proposition de travaux adaptée à mon projet</span>
                  </li>
                </ul>
              </div>

              <div className="description">
                <div className="mb-5 text-center font-extrabold text-[15px]">
                  Cette offre vous permet après avoir mesuré le niveau de
                  fiabilité de votre DPE, de vous projeter dans des travaux
                  permettant l'amélioration de votre logement selon votre projet
                  (gain de lettres, budget).
                </div>

                <div
                  className="flex items-center justify-center bg-bgPrimary text-white font-bold px-3 py-1 rounded-lg cursor-pointer mx-[20%] xl:mx-[25%]"
                  onClick={handleClickDemarrer}
                >
                  <span className="xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[14px] xs:text-[12px] text-center">
                    Démarrez mon projet avec checkDPE
                  </span>
                  <IconBar className="h-[30%] w-[30%] xl:h-[12%] xl:w-[12%]" />
                </div>
              </div>
            </div>
          )}
          {(isPending ) && (
            <div className="pending-container border-[3px] border-green rounded-[16px] p-4 flex-col items-center justify-center">
              <div className="flex items-center justify-center">
                <IconBar className="h-[15%] w-[15%] xl:h-[12%] xl:w-[12%]" />
              </div>
              <div className="text-center font-extrabold text-[15px] mb-5">
                Votre scénario travaux est en cours de réalisation. Dès que
                c'est prêt vous revevrez une notification par mail et les
                travaux recommandés s'afficheront ici
              </div>
            </div>
          )}
          {(isPrePending ) && (
            <div className="pending-container border-[3px] border-green rounded-[16px] p-4 flex-col items-center justify-center">
              <div className="flex items-center justify-center">
                <IconBar className="h-[15%] w-[15%] xl:h-[12%] xl:w-[12%]" />
              </div>
              <div className="text-center font-extrabold text-[15px] mb-5">
                Votre scénario travaux va démarrer, nous vous invitons à clicker sur "Démarrer mon projet" ci-dessous, afin de répondre à quelques questions sur votre projet.
              </div>
            </div>
          )}
        </Card>
      )}

                {isPrePending && (
            <Card className="mb-3 relative">
              <Flex  >
              <Flex align="left" className="mb-2 grow p-4 text-[16px]" vertical>
                <div className="text-gray-500">
                  Nous avons besoin de recueillir plus d'informations sur votre projet...
                </div>
              </Flex>
              <Flex className="items-center justify-end h-16">
                <Button
                  type="primary"
                  className="btn-rapport"
                  onClick={() => handleToInsight()}
                >
                  <IconStarContact className="w-8 h-8 mr-4" style={{fill: "rgb(255, 255, 255)" }} />
                  Démarrer mon projet
                </Button>
                {/* <IconStarContact className="w-8 h-8 mr-4" style={{fill: "rgb(59, 134, 134)" , cursor: "pointer"}}  onClick={handleToInsight}/> */}
              </Flex>

              </Flex>
            </Card>
          )}



      {!isPending && !isPrePending && (
        <Card className="mb-3 relative">
          {isConstruction && (
            <div className="overlay-2">
              <div className="top-[45%] left-[25%] w-[50%] text-center absolute border border-gray-400 text-gray-400 text-[22px] py-3 rotate-[-30deg]">
                Données Fictives
              </div>
            </div>
          )}
          <div className="energy-home__suggestion-renovation relative z-10">
            {!isConstruction && (
              <>
                <div className="flex items-center justify-between mb-3">
                  <h3 className="flex items-center gap-x-2.5 font-bold text-[28px] lg:text-[40px] leading-[48px] mb-3">
                    <IconPencil className="flex-shrink-0" />
                    <span>Les travaux pour améliorer mon DPE</span>
                  </h3>

                  <InfoCircleOutlined style={{ fontSize: 24 }} />
                </div>

                <div className="flex items-center mb-3 justify-between">
                  <div>
                    <h5>Scénario proposé par CheckDPE</h5>
                    <div className="flex items-center justify-between">
                      <div className="text-[18px]">
                        Vous souhaitez bénéficier d'une proposition de travaux
                        adaptée à votre projet
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="energy-home__suggestion-renovation__tabs">
              <Row gutter={[24, 24]}>
                <Col
                  span={24}
                  order={2}
                  lg={{
                    span: 15,
                    order: 2,
                  }}
                  xl={{
                    span: 17,
                    order: 1,
                  }}
                >
                  <Tabs
                    centered
                    activeKey={tab}
                    items={tabMapItems}
                    onChange={handleChangeTab}
                  />
                </Col>
                <Col
                  span={24}
                  order={1}
                  lg={{
                    span: 9,
                    order: 2,
                  }}
                  xl={{
                    span: 7,
                    order: 2,
                  }}
                >
                  {selectedTabContent && (
                    <div className="energy-home__montant">
                      <p className="flex items-center font-bold text-[24px] gap-x-1">
                        <IconEuro />
                        Montant des travaux
                      </p>
                      <p className="text-[20px] pl-7">
                        Entre {formatThousands(selectedTabContent.estimated_cost[0])}€ et{" "}
                        {formatThousands(selectedTabContent.estimated_cost[1])}€
                      </p>

                      <p className="flex items-center font-bold text-[24px] gap-x-1 mt-4">
                        <IconRise />
                        Passez de la lettre
                      </p>

                      <div className="flex items-center gap-x-[20px] pl-7 mt-2">
                        <div
                          className="montant-label"
                          style={{
                            background:
                              MAP_COLOR_DPE[
                                _.get(selectedTabContent, "gain.0", "")
                              ],
                          }}
                        >
                          {_.get(selectedTabContent, "gain.0", "")}
                        </div>
                        <span
                          className="text-[32px]"
                          style={{ color: "#414141" }}
                        >
                          à
                        </span>
                        <div
                          className="montant-label"
                          style={{
                            background:
                              MAP_COLOR_DPE[
                                _.get(selectedTabContent, "gain.1", "")
                              ],
                          }}
                        >
                          {_.get(selectedTabContent, "gain.1", "")}
                        </div>
                      </div>
                      {(selectedTabContent.estimated_value_gain?.[0] ?? 0) !== 0 && (
                        <div >
                        <p className="flex items-center font-bold text-[24px] gap-x-1" style={{marginTop: "20px"}}>
                          <ValuePlus />
                          Impact sur la valeur
                        </p>
                        <div className="flex items-center gap-x-[20px] pl-7 mt-2">
                          <ValuePlus2 className="w-10 h-10" />
                          <div
                            className="montant-label"
                            
                          >
                            <p className="text-[20px] pl-7">
                              +{formatThousands(selectedTabContent.estimated_value_gain?.[0] ?? 0)}€
                            </p>
                          </div>
                        </div>
                        </div>
                      )}
                      

                    </div>
                  )}

                  <div className="text-center" style={{marginLeft: isMobile ? "0" : "20px"}}>
                    {isLoadingDPE ? (
                      <div className="svg-image mx-auto">
                        <Skeleton.Button active />
                      </div>
                    ) : isSuccessDPE && ResultatDPE ? (
                      <img
                        src={`data:image/svg+xml;utf8,${encodeURIComponent(
                          ResultatDPE || ""
                        )}`}
                        alt="result"
                        className="mt-4"
                      />
                    ) : isSuccessDPE && !ResultatDPE ? (
                      <Empty imageStyle={{ height: 310, marginBottom: 0 }} />
                    ) : null}
                  </div>

                  {/* <Button className="btn-demarrer" onClick={handleClickDemarrer}>
          Démarrer une conversation
          </Button> */}
                </Col>
              </Row>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default SuggestionRenovation;
